var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTerminalAtivityLog(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.11111 11.8889H8.77778M4.11111 8.77778H8.77778M4.11111 5.66667H4.88889M7.22222 1H3.48889C2.6177 1 2.1821 1 1.84935 1.16955C1.55665 1.31868 1.31868 1.55665 1.16955 1.84935C1 2.1821 1 2.6177 1 3.48889V12.5111C1 13.3823 1 13.8179 1.16955 14.1507C1.31868 14.4433 1.55665 14.6813 1.84935 14.8304C2.1821 15 2.6177 15 3.48889 15H9.4C10.2712 15 10.7068 15 11.0396 14.8304C11.3322 14.6813 11.5702 14.4433 11.7193 14.1507C11.8889 13.8179 11.8889 13.3823 11.8889 12.5111V5.66667M7.22222 1L11.8889 5.66667M7.22222 1V4.42222C7.22222 4.85782 7.22222 5.07562 7.307 5.24199C7.38159 5.38834 7.50051 5.50732 7.64689 5.5819C7.81325 5.66667 8.03103 5.66667 8.46667 5.66667H11.8889",
    stroke: "#2F80ED",
    strokeWidth: 1.55556,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTerminalAtivityLog);
export default __webpack_public_path__ + "static/media/TerminalAtivityLog.7e116db6.svg";
export { ForwardRef as ReactComponent };